<template>
  <div class="dm-box">
    <!-- 用户进房动画 -->
    <div class="inRoomUser-box-div">
    	<div class="inRoomUser-box dm-slide-in"
    	    v-for="(item,index) in inUserList" 
    	    :key="`user-${index}`"
    	    :style="{zIndex: 10 - index}">
    	    <span class="inRoomUser-box-text">{{item.name}}：</span>
    	    <span class="inRoomUser-box-text1">{{$t('all.jinrulezhibojian')}}</span>
    	</div>
    </div>
	<div class="dm-box-container">
		<div class="dm-box-container-list" ref="danmuContainer">
			<div class="dm-box-container-list-item" v-for="(item,index) in msgList" :key="index">
				<div class="dm-box-container-list-item-box" @click="handleShowUser(item)">
				    <!-- 去掉flex容器，直接用文本流布局 -->
				    <div class="dm-content-wrapper">
				      <!-- 昵称作为文本流的第一个部分 -->
				      <span class="dm-box-container-list-item-text1" v-if="item.sendUserInfo">{{item.sendUserInfo.nickName}}：</span>
				      
				      <!-- 所有内容合并为一个文本块，换行时自然靠左 -->
				      <span class="dm-content-text">
						<template v-if="item.type == -1">
						  <img class="xiaolapa" src="../../assets/image/xlp.png" alt=""/>
						</template>
				        <template v-if="!item.sendUserInfo">
				          <span class="dm-box-container-list-item-text">{{item.title}}</span>
				        </template>
				        <template v-if="item.type == 3">
				          <span class="dm-box-container-list-item-text2">{{item.title}}</span>
				        </template>
				        <template v-if="item.type == 1">
				          <span class="dm-box-container-list-item-text3">{{item.title}}</span>
				        </template>
				        <template v-if="item.type == 12">
				          <span class="dm-box-container-list-item-text2">{{$t('all.songgei')}}{{item.toUserInfo.nickName}}{{item.giftInfo.content}}</span>
				          <img class="danmaku-body-item-box-img" :src="item.giftInfo.imgUrl" alt="" />
				          <span class="dm-box-container-list-item-text2">×{{item.num}}</span>
				        </template>
				      </span>
				    </div>
				  </div>
			</div>
		</div>
		<div class="dm-box-kjdy" v-if="show_kjdy && kjdyList.length > 0">
			<div class="dm-box-kjdy-item" v-for="(item,index) in kjdyList" :key="index" @click="handleFsKjdy(item.content)">{{item.content}}</div>
			<img class="closeKjdy" src="../../assets/image/x_22_1@2x.png" alt="" @click="show_kjdy = false"/>
		</div>
		<div class="dm-box-textarea">
			<textarea v-model="form.content" :placeholder="$t('all.shuodianshenmene')" placeholder-style="color:rgba(255,255,255,0.6)" @keydown.enter="handleEnter"></textarea>
		</div>
	</div>
	
  </div>
</template>

<script>
import { getLiveCommonExpressionsList,getChatRoomDetails,chatRoomSendMsg } from "@/api/zhibo";
export default {
  name: 'Danmu',
  data() {
    return {
      inUserList: [],
      userQueue: [],
      isUserAnimating: false,
      animateTotalTime: 3000,
      animateGap: 1000, 
	  msgList: [{
		title:this.$t('all.danmushuoming')
	}],
	  form:{
		content:'',  
	  },
	  kjdyList:[],
	  show_kjdy:true,
    };
  },
  mounted() {
	this.$ws.connect(this.$route.query.liveId,this.$store.state.userId);
	this.getMessage()
	this.getLiveCommonExpressionsList()
	this.getChatRoomDetails()
  },
  beforeDestroy() {
    console.log(this.$ws,'this.$ws');
    this.$ws.close()
  },
  methods: {
	getMessage(){
		this.$ws.onMessage = res=> {
			if (res) {
				const data = JSON.parse(res)
				if(data.data && data.data.pushType == 1){
					console.log(data,123)
					const newUser = {
						name: data.data.details.sendUserInfo.nickName
					};
					this.addUserToQueue(newUser);
					let msg = data.data.details
					msg.title = this.$t('all.jinrulezhibojian')
					msg.type = 1
					this.msgList.push(msg)
					this.$nextTick(() => {
						this.scrollToBottom();
					});
					this.$emit('changeUser')
				}
				if(data.data && data.data.pushType == 2){
					console.log(data,123)
					this.$emit('changeUser')
				}
				if(data.data && data.data.pushType == 3){
					console.log(data)
					let msg = data.data.details
					msg.title = data.data.content
					this.msgList.push(msg)
					msg.type = 3
					this.$nextTick(() => {
						this.scrollToBottom();
					});
				}
				
				if(data.data && data.data.pushType == 4){
					
				}
				if(data.data && data.data.pushType == 5){
					
				}
				if(data.data && data.data.pushType == 6){
					
				}
				if(data.data && data.data.pushType == 7){
					
				}
				if(data.code == 401){
					window.location.reload();
				}
				if(data.data && data.data.pushType == 12){
					//b被踢出直播间
					this.$router.go(-1);
				}
				if(data.data && data.data.pushType == 16){
					//推送礼物
					console.log(data.data)
					const newGift = data.data
					// this.addLwToQueue(newGift);
					let msg = data.data.details
					msg.type = 12
					this.msgList.push(msg)
					this.$nextTick(() => {
						this.scrollToBottom();
					});
					this.$emit('addLwToQueue',newGift)
					this.$emit('addSvgaToQueue',data.data.details.giftInfo.gifUrl)
				}
				if(data.data && data.data.pushType == 21){
					//房间被关闭
					this.$router.go(-1);
				}
				if(data.data && data.data.pushType == 24){
					//更新直播间常用语
					this.getLiveCommonExpressionsList()
				}
				
			}	
			
		}
	},
	//直播间信息
	async getChatRoomDetails(){
		const res = await getChatRoomDetails({liveId:this.$route.query.liveId})
		if(res.data.chatRoomDetails.noticeText){
			this.msgList.push({
				type:-1,
				title:res.data.chatRoomDetails.noticeText
			})
		}
	},
	//快捷短语
	async getLiveCommonExpressionsList(){
		const res = await getLiveCommonExpressionsList({liveId:this.$route.query.liveId})
		this.kjdyList = res.data
	},
	//发送信息
	async handleEnter(event) {
	    event.preventDefault(); // 1. 阻止textarea的默认回车换行行为
	    // 2. 去除首尾空格，并将内容中的所有换行符替换为空字符串
	    const contentToSend = this.form.content.trim().replace(/\n/g, '');
	    // 3. 如果处理后内容为空，则不发送
	    if (!contentToSend) {
	        return;
	    }
	    const params = {
	        liveId: this.$route.query.liveId,
	        content: contentToSend // 4. 发送处理后的内容
	    };
	    await chatRoomSendMsg(params);
	    this.form.content = ''; // 5. 清空输入框
	},
	//发送快捷短语
	async handleFsKjdy(content){
		const params = {
		    liveId: this.$route.query.liveId,
		    content: content // 4. 发送处理后的内容
		};
		await chatRoomSendMsg(params);
	},
    /**
     * 将新用户添加到队列中
     * @param {object} user - 用户对象
     */
    addUserToQueue(user) {
      if (!user || !user.name) return;
      // 生成一个唯一ID，用于后续移除
      user.id = Date.now() + Math.random().toString(36).substr(2, 9);
      this.userQueue.push(user);
      
      // 如果当前没有动画在播放，则立即开始播放下一个
      if (!this.isUserAnimating) {
        this.showNextUser();
      }
    },

    /**
     * 显示队列中的下一个用户通知
     */
    showNextUser() {
      // 如果队列为空，则结束动画流程
      if (this.userQueue.length === 0) {
        this.isUserAnimating = false;
        return;
      }

      this.isUserAnimating = true;
      // 从队列头部取出一个用户
      const user = this.userQueue.shift();
      // 将用户添加到显示列表中，触发CSS动画
      this.inUserList.push(user);

      // 等待动画完全播放完毕后 (3秒)，从显示列表中移除该用户
      setTimeout(() => {
        this.inUserList = this.inUserList.filter(item => item.id !== user.id);

        // 在移除后，等待一个间隔时间 (1秒)，再继续显示队列中的下一个用户
        setTimeout(() => {
          this.showNextUser();
        }, this.animateGap);

      }, this.animateTotalTime);
    },
	//滚动到底部
	scrollToBottom() {
	  this.$nextTick(() => {
		const container = this.$refs.danmuContainer;
		container.scrollTop = container.scrollHeight;
	  });
	},
	//显示用户信息
	handleShowUser(data){
		if(data.sendUserInfo){
			this.$emit('show_user',data.sendUserId)
		}
	}
  },
};
</script>

<style scoped lang="scss">
    @import "./danmu.css";
	
</style>


// WEBPACK FOOTER //
// danmu.vue?31758323